"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TintAndShadeCalculator = void 0;
var TintAndShadeCalculator = (function () {
    function TintAndShadeCalculator() {
    }
    TintAndShadeCalculator.modifyShadeToTint = function (shade) {
        return (shade / TintAndShadeCalculator.maxTintValue) - 1;
    };
    TintAndShadeCalculator.calculateTint = function (tint) {
        return (1 - tint / TintAndShadeCalculator.maxTintValue);
    };
    TintAndShadeCalculator.calculateShadeFromColorModelInfoTint = function (tint) {
        return Math.floor((tint + 1) * TintAndShadeCalculator.maxTintValue);
    };
    TintAndShadeCalculator.calculateTintFromColorModelInfoTint = function (tint) {
        return Math.floor(TintAndShadeCalculator.maxTintValue * (1 - tint));
    };
    TintAndShadeCalculator.maxTintValue = 255;
    return TintAndShadeCalculator;
}());
exports.TintAndShadeCalculator = TintAndShadeCalculator;
